export default __webpack_public_path__ + "static/course-image-1-7324920e6f87d018aafaf3d1f13fa52c.jpg";